import { Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { NgxPrinterService } from 'ngx-printer';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { State } from 'src/app/reducers';
import { loadUserAssessment } from 'src/app/store/assessment/assessment.actions';
import { UserAssessment } from 'src/app/store/assessment/assessment.models';
import { User } from 'src/app/store/auth/auth.models';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';


@Component({
  selector: 'app-assessment-review',
  templateUrl: './assessment-review.component.html',
  styleUrls: ['./assessment-review.component.scss']
})
export class AssessmentReviewComponent implements OnInit, OnDestroy {
  private destroyer$: Subject<any> = new Subject();
  @ViewChild('content') content: ElementRef;

  loadingUserAssessment: boolean = false;
  loadingUserAssessmentError: string = null;
  userAssessment: UserAssessment = null;
  currentUser: User = null;
  pageReady = false;

  constructor(private store: Store<State>, private activatedRoute: ActivatedRoute, private printerService: NgxPrinterService) {

    this.store.select(state => state.assessments.loadingAssessmentError).pipe(takeUntil(this.destroyer$)).subscribe(
      (error) => {
        if (error) {
          this.loadingUserAssessmentError = error;
          this.pageReady = true;
        }
      }
    );
    this.activatedRoute.params.subscribe(params => {
      if (params && params.assessmentId) {
        this.store.select(state => state.auth.authenticatedUser).pipe(takeUntil(this.destroyer$)).subscribe(user => {
          this.currentUser = user;

          if (user) {
            // fetch the assessment
            this.store.dispatch(loadUserAssessment({userId: user.sub, assessmentId: params.assessmentId}));

            // listen to it
            this.store.select(state => state.assessments.currentUserAssessment).pipe(takeUntil(this.destroyer$)).subscribe(userAssessment => {
              if (userAssessment) {
                this.userAssessment = userAssessment;
                this.pageReady = true;
              }
            });
          }
        });
      }
    });
  }

  saveAsPDF(): void {
    let data = document.getElementById('content');
    html2canvas(data, {
      allowTaint: true,
      useCORS: true,
      logging: false,
      height: window.outerHeight + window.innerHeight,
      windowHeight: window.outerHeight + window.innerHeight
    }).then(canvas => {
      let fileWidth = 208;
      let fileHeight = canvas.height * fileWidth / canvas.width;

      const FILEURI = canvas.toDataURL('image/png')
      let PDF = new jspdf('p', 'mm', 'a4');
      let position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      PDF.save(`${this.userAssessment.id}_result.pdf`);
    })
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroyer$.next(true);
    this.destroyer$.complete();
  }
}
